import { setUpListener } from './gss-nav';
import { Settings } from 'luxon';
setUpListener();
Settings.defaultLocale = 'sv-SE';
